import React from "react";
import BootstrapTooltip from "./index";
import { DemoModeDisabledTooltipStyle } from "./style";
import * as theme from "../../theme";

export const DemoModeDisabledTooltip = ({ isHide, children, ...props }) => {
  return (
    <BootstrapTooltip
      {...props}
      title={<DemoModeDisabledTooltipContent />}
      color={`${theme.palette.white}`}
      boxShadow
      width={"325px"}
      isHide={isHide}
    >
      {children}
    </BootstrapTooltip>
  );
};

const DemoModeDisabledTooltipContent = () => {
  return (
    <DemoModeDisabledTooltipStyle>
      <div className="icon" />
      <div className="content">
        <div className="heading">Demo Mode</div>
        <div className="description">This cannot be done in demo mode.</div>
      </div>
    </DemoModeDisabledTooltipStyle>
  );
};
